import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import {
  ROUTE_CODE_CATEGORIES,
  ROUTE_CODE_CATEGORIES_DETAILS,
  ROUTE_CODE_CATEGORIES_CROSSWALK,
  ROUTE_DASHBOARD,
} from '../../constants';
import Suspense from '../../services/lazyLoad/Suspense';
import { useCodeCrosswalkEntitled } from '../../utils/codeCrosswalkEntitlement';

const CodeCategories = React.lazy(() => import('./CodeCategories'));
const CodeCategoriesDetails = React.lazy(() => import('./Details'));
const CodeCategoriesCrosswalk = React.lazy(() => import('./Crosswalk'));

export function CodeCrosswalkRoute() {
  const isEntitled = useCodeCrosswalkEntitled();

  if (!isEntitled) {
    return <Redirect to={ROUTE_DASHBOARD.path} />;
  }

  return <CodeCategoriesCrosswalk />;
}

export default function CodeCategoriesWrapper() {
  return (
    <Suspense>
      <Switch>
        <Route exact path={ROUTE_CODE_CATEGORIES_CROSSWALK.path}>
          <CodeCrosswalkRoute />
        </Route>
        <Route exact path={ROUTE_CODE_CATEGORIES_DETAILS.path}>
          <CodeCategoriesDetails />
        </Route>
        <Route exact path={ROUTE_CODE_CATEGORIES.path}>
          <CodeCategories />
        </Route>
        <Redirect exact path="/*" to={ROUTE_CODE_CATEGORIES.path} />
      </Switch>
    </Suspense>
  );
}
